import { fetchJson } from "../../../../utils";
import { reportError } from "../../basket-v2/errorReporting";
import { constants } from "../../common";
import { RemoveBasketItemRequest, BasketResponse, ApiResponseWithData } from "./models";

export async function removeFromBasket(request: RemoveBasketItemRequest) {
  const { success, errors, data } = await fetchJson<ApiResponseWithData<BasketResponse>>(constants.urls.basketV2.remove, {
    method: "DELETE",
    body: JSON.stringify(request),
  });

  if (success) {
    return data;
  } else {
    reportError("ft", errors.map((e) => e.message).join(", "));
    return false;
  }
}
